// Module
var code = "<div id=\"chat-button\" class=\"chat-button bg-primary\" data-bs-toggle=\"modal\" data-bs-target=\"#chatModal\"> <i class=\"bi bi-question-circle\"></i> <span id=\"unread-messages\" style=\"display:none\" class=\"badge badge-heart-count position-absolute translate-middle bg-danger text-white\"></span> </div>";
// Exports
module.exports = code;